interface IImageSize {
  width: number
  height: number
}

// Размеры читаем до отправки: сервер отбивает мелкие картинки, но ответ приходит
// уже после заливки всей формы
export const getImageSize = (file: File): Promise<IImageSize | null> =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const image = new window.Image()
    image.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: image.naturalWidth, height: image.naturalHeight })
    }
    image.onerror = () => {
      URL.revokeObjectURL(url)
      resolve(null)
    }
    image.src = url
  })
